import Utils from '../../../../common/js/Utils';

export default class Quiz {

    static initializeEvents() {
        // ===== Quiz with multiples questions (with a stepper) =====
        Array
            .from(document.querySelectorAll('.quiz .quiz-question label'))
            .forEach(label => {
                // Keyboard events for accessibility
                const relatedInput = document.getElementById(label.getAttribute('for'));
                relatedInput.addEventListener('keydown', event => {
                    if (event.target.type === 'checkbox' && event.code === 'Enter') {
                        event.target.checked = !event.target.checked;
                    }

                    if (event.target.type !== 'checkbox' && (event.code === 'Enter' || event.code === 'Space')) {
                        event.preventDefault();

                        // Trigger a "click" event to related label of current input
                        const label = document.querySelector('label[for="' + event.target.getAttribute('id') + '"]');
                        label.dispatchEvent(new Event('click'));
                    }
                });

                label.addEventListener('click', event => {
                    // Do not trigger event is input is disabled
                    const input = document.getElementById(event.currentTarget.getAttribute('for'));
                    if (input.disabled) {
                        return;
                    }

                    const doNotPerformValidation = event.detail === undefined || event.detail.performValidation !== true;
                    if (doNotPerformValidation) {
                        input.addEventListener('change', (e) => {
                            e.preventDefault();
                            const withoutValidation = Utils.parent(e.currentTarget, '.quiz').getAttribute('data-without-direct-validation') === 'true';
                            if(withoutValidation){
                                const errorElement = Utils.parent(e.currentTarget, '.input-group');
                                const errorMessage = errorElement.querySelector('.input-error-text');
                                errorElement.classList.remove('input-group-error');
                                errorMessage.classList.add('hidden');
                                errorMessage.ariaHidden = 'true';
                            }
                            this.multipleChoicesQuestionEvent(e.currentTarget, doNotPerformValidation);
                        }, {once: true});
                    }

                    this.multipleChoicesQuestionEvent(event.currentTarget, doNotPerformValidation);
                });
            });

        // ===== Quiz with only one question (two choices: right or wrong) =====
        Array
            .from(document.querySelectorAll('.quiz .quiz-question button[id^="choice-"]:not([draggable="true"])'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    this.oneChoiceQuestionEvent(event.currentTarget);
                });
            });

        // ===== Pair quiz (multiple choice in drag and drop) =====
        Array
            .from(document.querySelectorAll('.quiz .quiz-dropzone'))
            .forEach(dropzone => {
                dropzone.addEventListener('dragover', event => {
                    event.preventDefault();

                    event.dataTransfer.dropEffect = 'link';
                    event.currentTarget.classList.add('dropzone-over');
                });

                dropzone.addEventListener('dragleave', event => {
                    event.preventDefault();

                    event.currentTarget.classList.remove('dropzone-over');
                });

                dropzone.addEventListener('drop', this.draggableChoiceQuestionEvent.bind(this));
            });

        Array
            .from(document.querySelectorAll('.quiz button[draggable="true"]'))
            .forEach(button => {
                button.addEventListener('dragstart', event => event.dataTransfer.setData('text/plain', event.target.id));
                button.addEventListener('click', event => {
                    const dropzone = Utils.parent(event.currentTarget, '.quiz-question').querySelector('.quiz-dropzone');
                    Object.defineProperty(event, 'currentTarget', {value: dropzone});

                    // Simple hack to trigger a drag event
                    event.dataTransfer = new DataTransfer();
                    event.dataTransfer.setData('text/plain', event.target.id);

                    this.draggableChoiceQuestionEvent.bind(this)(event);
                });
            });
    }

    /**
     * Quiz with multiples questions (with a stepper)
     *
     * @param {HTMLLabelElement} label
     * @param {Boolean} doNotPerformValidation
     */
    static multipleChoicesQuestionEvent(label, doNotPerformValidation) {
        // Set variables
        const quizElement = Utils.parent(label, '.quiz');
        const questionElement = Utils.parent(label, '.quiz-question');
        const questionText = questionElement.querySelector('.question-text');
        const selectedChoices = Array.from(questionElement.querySelectorAll(':checked'));
        const selectedChoicesCount = selectedChoices.length;
        const withoutValidation = quizElement.getAttribute('data-without-direct-validation') === 'true';

        const fieldset = Utils.parent(label, 'fieldset');
        const dataAnswers = fieldset ? fieldset.getAttribute('data-answers') : null;
        if (dataAnswers) {
            const selectedChoicesMax = dataAnswers.split('-');
            const maxChecked = parseInt(selectedChoicesMax[1], 10);

            if (selectedChoicesCount > maxChecked) {
                if (questionElement.getAttribute('data-last-checked')) {
                    const lastCheckedId = questionElement.getAttribute('data-last-checked');
                    selectedChoices.some(choice => {
                        if (choice.id === lastCheckedId) {
                            choice.checked = false;
                            questionElement.setAttribute('data-last-checked', label.id);
                            return true;
                        }
                        return false;
                    });
                } else {
                    let selectedChoicesCount = 0;
                    for (let i = 0; i < selectedChoices.length; i++) {
                        if (label.id !== selectedChoices[i].id) {
                            selectedChoicesCount++;
                        }
                        if (selectedChoicesCount > (maxChecked - 1) && label.id !== selectedChoices[i].id) {
                            selectedChoices[i].checked = false;
                        }
                        if (selectedChoicesCount === (maxChecked - 1)) {
                            questionElement.setAttribute('data-last-checked', label.id);
                        }
                    }
                }
            }

            if (selectedChoicesCount === maxChecked) {
                if (label.id) {
                    questionElement.setAttribute('data-last-checked', label.id);
                }
            }
        }

        // Even if there is a right or wrong answer, this is not indicated to the user
        if (withoutValidation) {
            if (!questionElement.querySelector('.btn:not(.question-validate)')) {
                // Add previous question button
                if (questionElement.previousElementSibling.classList.contains('quiz-question')) {
                    questionElement.appendChild(this.getPreviousButton());
                }

                // Add next question button
                questionElement.appendChild(this.getNextButton(questionElement.nextElementSibling));
            }

            return;
        }

        // Add a button for the user to validate his answer
        if (doNotPerformValidation) {
            const questionValidationButton = questionElement.querySelector('.question-validate');
            if (questionValidationButton === null && selectedChoicesCount >= 1) {
                // Add validate question button
                questionElement.appendChild(this.getValidateButton(questionElement.nextElementSibling));
            } else if (questionValidationButton !== null && selectedChoicesCount === 0) {
                // Remove validation question button
                questionValidationButton.parentNode.removeChild(questionValidationButton);
            }

            return;
        }

        // Perform validation
        const goodChoices = questionElement.querySelector('[data-result]').getAttribute('data-result').split(',');
        const isGoodChoice = goodChoices.length === selectedChoices.length && selectedChoices.every(selectedChoice => goodChoices.includes(selectedChoice.id));

        // Show result
        questionText.insertBefore(this.getQuestionResult(isGoodChoice), questionText.firstChild);

        this.showElement(questionText);
        this.showElement(questionText.querySelector(isGoodChoice ? '.question-text-right' : '.question-text-wrong'));

        // Disable new choice on current question
        questionElement.querySelectorAll('input').forEach(choice => {
            choice.setAttribute('disabled', '');
            choice.parentElement.classList.add('disabled');
        });

        // Add previous question button
        if (questionElement.previousElementSibling.classList.contains('quiz-question')) {
            questionElement.appendChild(this.getPreviousButton());
        }

        // Add next question button
        questionElement.appendChild(this.getNextButton(questionElement.nextElementSibling));
    }

    /**
     * Quiz with only one question (two choices: right or wrong)
     *
     * @param {HTMLButtonElement} button
     */
    static oneChoiceQuestionEvent(button) {
        // Set variables
        const questionElement = button.parentElement;
        const questionText = questionElement.querySelector('.question-text');
        const isGoodChoice = questionElement.getAttribute('data-result') === button.id || questionElement.getAttribute('data-result').includes('both');

        // Attribute for accessibility
        button.setAttribute('aria-pressed', 'true');

        // Show result
        questionText.insertBefore(this.getQuestionResult(isGoodChoice), questionText.firstChild);
        this.showElement(questionText);

        // Disable new click on button
        Array.from(questionElement.querySelectorAll('button[id^="choice-"]')).forEach(otherButton => {
            if (otherButton.id !== button.id) {
                otherButton.classList.add('disabled');
                otherButton.setAttribute('disabled', '');
            }

            // Simple hack to remove all events of button
            otherButton.replaceWith(otherButton.cloneNode(true));
        });
    }

    static draggableChoiceQuestionEvent(event) {
        event.preventDefault();

        const choiceId = event.dataTransfer.getData('text/plain');
        if (!choiceId.startsWith('choice-')) {
            return;
        }

        const questionElement = Utils.parent(event.currentTarget, '.quiz-question');
        const questionHasMultipleResults = questionElement.getAttribute('data-result').includes(',');
        const filledChoice = event.currentTarget.querySelector('.tag:last-child');

        if (!questionHasMultipleResults && filledChoice) {
            this.unselectDropzoneChoice(questionElement, {currentTarget: filledChoice});
        } else if (!questionElement.querySelector('.btn')) {
            // Add previous question button
            if (questionElement.previousElementSibling.classList.contains('quiz-question')) {
                questionElement.appendChild(this.getPreviousButton());
            }

            // Add next question button
            questionElement.appendChild(this.getNextButton(questionElement.nextElementSibling));
        }

        const choice = document.getElementById(choiceId);

        // Do not allow multiple selection of the same choice
        if (event.currentTarget.querySelector('[data-target-id="' + choice.id + '"]')) {
            return;
        }

        // Duplicate selected choice to drop zone
        const choiceClone = choice.cloneNode(true);
        choiceClone.removeAttribute('id');
        choiceClone.removeAttribute('draggable');
        choiceClone.setAttribute('title', 'Cliquez ici pour retirer la réponse : ' + choiceClone.innerText.trim());
        choiceClone.setAttribute('data-target-id', choice.id);
        choiceClone.setAttribute('aria-selected', 'true')
        choiceClone.innerHTML += '<i class="ri-close-line ml-auto" aria-hidden="true"></i>';

        choiceClone.classList.remove('w-md-auto');
        choiceClone.classList.remove('mr-3w', 'mb-2w', 'cursor-grab');
        choiceClone.addEventListener('click', e => this.unselectDropzoneChoice(questionElement, e));
        choiceClone.focus();

        // Update dropzone
        event.currentTarget.appendChild(choiceClone);
        event.currentTarget.classList.add('dropzone-filled');
        event.currentTarget.classList.remove('dropzone-over');

        // Disable selected choice
        if (!questionHasMultipleResults) {
            choice.removeAttribute('draggable');
        }

        choice.classList.add('disabled');
        choice.setAttribute('disabled', '');

        // Store user choices to current question
        const selectedChoices = (questionElement.getAttribute('data-choices') || '').split(',').filter(id => id !== '');
        selectedChoices.push(choice.id);
        questionElement.setAttribute('data-choices', selectedChoices.join(','));

        // Perform validation
        const goodChoices = questionElement.getAttribute('data-result').split(',');
        const isGoodChoice = goodChoices.length === selectedChoices.length && selectedChoices.every(selectedChoice => goodChoices.includes(selectedChoice));

        if (isGoodChoice) {
            questionElement.classList.add('success');
        } else {
            questionElement.classList.remove('success');
        }
    }

    static getQuestionResult(success) {
        const result = document.createElement('p');
        result.classList.add('alert', 'alert-' + (success ? 'success' : 'error'), 'inline-block', 'hidden-print', 'mb0')
        result.innerText = success ? 'Bonne réponse' : 'Mauvaise réponse';

        return result;
    }

    static getQuizResult(numberOfQuestions, numberOfGoodQuestions, successPercent) {
        // Get result level
        let resultLevel;
        if (successPercent >= 80) {
            resultLevel = 1;
        } else if (successPercent >= 60 && successPercent <= 79) {
            resultLevel = 2;
        } else if (successPercent >= 40 && successPercent <= 59) {
            resultLevel = 3;
        } else if (successPercent >= 20 && successPercent <= 39) {
            resultLevel = 4;
        } else {
            resultLevel = 5;
        }

        // Create element
        const result = document.createElement('p');
            result.dataset.level = resultLevel;
            result.innerHTML = `<strong>Votre score :</strong> ${numberOfGoodQuestions} / ${numberOfQuestions}`;
        return result;
    }

    static getPreviousButton() {
        const button = document.createElement('button');
        button.classList.add('btn', 'secondary', 'mt-4w', 'mr-3w', 'hidden-print');
        button.innerText = 'Retour';
        button.addEventListener('click', this.previousQuestion.bind(this));

        // Icon in button
        const icon = document.createElement('i');
        icon.classList.add('ri-arrow-left-line');
        icon.setAttribute('aria-hidden', 'true');

        button.insertBefore(icon, button.firstChild);

        return button;
    }

    static getNextButton(nextElement) {
        const isLastQuestion = nextElement === null || !nextElement.classList.contains('quiz-question');
        const button = document.createElement('button');
        button.classList.add('btn', 'mt-4w', 'hidden-print')
        button.innerText = isLastQuestion ? 'Terminer' : 'Question suivante';
        button.addEventListener('click', this.nextQuestion.bind(this));

        return button;
    }

    static getValidateButton() {
        const button = document.createElement('button');
        button.classList.add('question-validate', 'btn', 'mt-4w', 'hidden-print');
        button.innerText = 'Valider';
        button.addEventListener('click', this.validateQuestion.bind(this));

        // Icon in button
        const icon = document.createElement('i');
        icon.classList.add('ri-arrow-right-line');
        icon.setAttribute('aria-hidden', 'true');

        button.insertBefore(icon, button.firstChild);

        return button;
    }

    static showQuestionRecap(question) {
        const recap = question.querySelector('.question-recap');
        if (recap) {
            const questionChoices = Array.from(question.querySelectorAll('.dropzone .tag')).map(choice => choice?.innerText?.trim()).join('&comma; ');
            const questionChoicesText = (questionChoices.includes('&comma;') ? 'Vos réponses : ' : 'Votre réponse : ') + questionChoices;

            let alert;
            if (question.classList.contains('success')) {
                alert = recap.querySelector('.alert-success');
                alert.removeAttribute('hidden');
            } else {
                alert = recap.querySelector('.alert-error');
                alert.removeAttribute('hidden');
            }

            const text = document.createElement('p');
            text.classList.add('text-grey-200');
            text.innerHTML = questionChoicesText;
            recap.insertBefore(text, alert);

            this.showElement(recap);

            question.parentNode.appendChild(recap);
        }
    }

    static updateStepper(stepper, direction) {
        // Update stepper steps
        const stepperSteps = stepper.querySelector('.stepper-steps');
        const currentStepNumber = parseInt(stepperSteps.style.getPropertyValue('--current-step'));
        const newStepNumber = direction === 'next' ? currentStepNumber + 1 : currentStepNumber - 1;
        stepperSteps.style.setProperty('--current-step', newStepNumber);

        // Update stepper title
        const stepperTitle = stepper.querySelector('.stepper-title');
        const stepperTitleText = stepperTitle.querySelector('span:last-child');
        stepperTitleText.innerText = stepperTitleText.innerText.replace(currentStepNumber, newStepNumber);
        const stepperTitleState = stepperTitle.querySelector('.stepper-title .stepper-state');
        stepperTitleState.innerText = stepperTitleState.innerText.replace(currentStepNumber, newStepNumber);
    }

    static previousQuestion(event) {
        const currentQuestion = event.currentTarget.parentNode;
        const previousQuestion = currentQuestion.previousElementSibling;

        if (previousQuestion.classList.contains('quiz-question')) {
            // Update stepper
            const stepper = currentQuestion.parentNode.querySelector('.stepper');
            this.updateStepper(stepper, 'previous');

            // Hide current question
            this.hideElement(currentQuestion);

            // Move quiz choices to new question
            const quizChoices = currentQuestion.querySelector('.quiz-choices');
            if (quizChoices) {
                // Before move, re-enable all choices
                Array
                    .from(quizChoices.querySelectorAll('button[draggable="true"].disabled'))
                    .forEach(choice => choice.classList.remove('disabled'));

                previousQuestion.insertBefore(quizChoices, previousQuestion.lastElementChild.previousElementSibling);
            }

            // Show previous question
            this.showElement(previousQuestion);
        }
    }

    static nextQuestion(event) {
        const currentQuestion = event.currentTarget.parentNode;
        const quizElement = currentQuestion.parentNode
        const nextQuestion = currentQuestion.nextElementSibling
        const withoutValidation = quizElement.getAttribute('data-without-direct-validation') === 'true';
        const quizEnabledPlugins = quizElement.getAttribute('data-quiz-enabled-plugins');

        if(currentQuestion.querySelectorAll(':checked').length === 0 && !currentQuestion.getAttribute('data-result') &&  withoutValidation){
            const errorElements = currentQuestion.getElementsByClassName("input-group");
            const errorElement = errorElements[0];
            const errorMessage = currentQuestion.querySelector('.input-error-text');
            if (errorElements.length > 0) {
                errorElement.classList.add('input-group-error');
                errorMessage.classList.remove('hidden');
                errorMessage.ariaHidden = 'false';

            }
            return false
        }
        // Hide current question
        this.hideElement(currentQuestion);

        // End of quiz
        if (nextQuestion === null || !nextQuestion.classList.contains('quiz-question')) {
            // Validate quiz
            const numberOfQuestions = quizElement.querySelectorAll('.quiz-question').length;
            const numberOfGoodQuestions = quizElement.querySelectorAll('.quiz-question.success, .quiz-question .alert.alert-success:not([hidden])').length;
            const successPercent = Math.ceil((numberOfGoodQuestions * 100) / numberOfQuestions);

            //hide steper
            if (document.querySelector('.stepper')) {
                const stepper= quizElement.querySelector('.stepper');
                stepper.style.display = 'none';
            }

            //text result
            if (document.querySelector('.quiz-text-result')) {
                const title= quizElement.querySelector('.quiz-text-result');
                title.innerText = 'Votre résultat';
                title.style.marginTop = "16px";
            }

            // Show quiz result
            if (document.querySelector('.quiz-result')) {
                const quizResult = quizElement.querySelector('.quiz-result');
                const quizResultCompiled = this.getQuizResult(numberOfQuestions, numberOfGoodQuestions, successPercent);

                const quizResultLevelElement = quizResult.querySelector('.quiz-result-level-' + quizResultCompiled.dataset.level);
                if (quizResultLevelElement) this.showElement(quizResultLevelElement);
                if ( quizEnabledPlugins !== 'QuizPositioning' ) {
                    quizResult.insertBefore(quizResultCompiled, quizResult.firstChild);
                }
                this.showElement(quizResult);
            } else {

            }

            // Hide quiz order
            const quizOrder = quizElement.querySelector('.quiz-order');
            if (quizOrder) this.hideElement(quizOrder);

            // Hide quiz choices
            const quizChoices = quizElement.querySelector('.quiz-choices');
            if (quizChoices) this.hideElement(quizChoices);

            // Quiz with a recap of questions
            if (quizElement.classList.contains('quiz-with-recap')) {
                const stepperTitle = quizElement.querySelector('.stepper .stepper-title');
                if (stepperTitle) this.hideElement(stepperTitle);

                Array
                    .from(quizElement.querySelectorAll('.quiz-question'))
                    .forEach(this.showQuestionRecap.bind(this));
            }

            // Scroll to top of quiz
            quizElement.scrollIntoView({behavior: 'smooth'});

            // Send custom event for other scripts
            const endOfQuizEvent = new CustomEvent('quizEnd', {
                detail: {
                    contentId: quizElement.getAttribute('data-content-id'),
                    locationId: quizElement.getAttribute('data-location-id'),
                    enabledPlugins: quizElement.getAttribute('data-quiz-enabled-plugins'),
                    identificationType: quizElement.getAttribute('data-identification-type'),
                    identificationIdentifier: quizElement.getAttribute('data-identification-identifier'),
                }
            });

            quizElement.dispatchEvent(endOfQuizEvent);

            return;
        }

        if (nextQuestion.classList.contains('quiz-question')) {
            // Update stepper
            const stepper = currentQuestion.parentNode.querySelector('.stepper');
            this.updateStepper(stepper, 'next');

            // Move quiz choices to new question
            const quizChoices = quizElement.querySelector('.quiz-choices');
            if (quizChoices) {
                // Before move, re-enable all choices
                Array
                    .from(quizChoices.querySelectorAll('button[draggable="true"].disabled'))
                    .forEach(choice => choice.classList.remove('disabled'));

                const questionFirstButton = nextQuestion.querySelector('.btn');
                if (questionFirstButton) {
                    nextQuestion.insertBefore(quizChoices, questionFirstButton);
                } else {
                    nextQuestion.appendChild(quizChoices);
                }
            }

            // Even if there is a right or wrong answer, this is not indicated to the user
            const withoutValidation = quizElement.getAttribute('data-without-direct-validation') === 'true';
            if (withoutValidation && !nextQuestion.querySelector('.btn')) {
                // Add previous question button
                if (nextQuestion.previousElementSibling.classList.contains('quiz-question')) {
                    nextQuestion.appendChild(this.getPreviousButton());
                }

                // Add next question button
                nextQuestion.appendChild(this.getNextButton(nextQuestion.nextElementSibling));
            }

            // Show next question
            this.showElement(nextQuestion);

            // Scroll to top of quiz
            quizElement.scrollIntoView({behavior: 'smooth'});
        }
    }

    static validateQuestion(event) {
        const currentQuestion = event.currentTarget.parentNode;
        const clickEvent = new CustomEvent('click', {
            detail: {
                performValidation: true
            }
        });

        // Send click event to trigger question validation
        currentQuestion.querySelector('label').dispatchEvent(clickEvent);

        // Remove validate button
        currentQuestion.removeChild(event.currentTarget);
    }

    static unselectDropzoneChoice(questionElement, event) {
        const currentChoice = event.currentTarget;
        const targetChoiceId = currentChoice.getAttribute('data-target-id');
        const targetChoice = document.getElementById(targetChoiceId);

        // Remove current choice
        const newSelectedChoices = (questionElement.getAttribute('data-choices') || '').split(',').filter(id => id !== targetChoiceId);
        questionElement.setAttribute('data-choices', newSelectedChoices.join(','));

        // Perform validation
        const goodChoices = questionElement.getAttribute('data-result').split(',');
        const isGoodChoice = goodChoices.length === newSelectedChoices.length && newSelectedChoices.every(selectedChoice => goodChoices.includes(selectedChoice));

        if (isGoodChoice) {
            questionElement.classList.add('success');
        } else {
            questionElement.classList.remove('success');
        }

        if (currentChoice.parentNode.querySelectorAll('.tag').length === 1) {
            currentChoice.parentNode.classList.remove('dropzone-filled');
        }

        targetChoice.setAttribute('draggable', 'true');
        targetChoice.classList.remove('disabled');
        targetChoice.removeAttribute('disabled');

        currentChoice.parentNode.removeChild(currentChoice);
    }

    static showElement(element) {
        element.classList.remove('hidden', 'hidden-screen');
        element.removeAttribute('aria-hidden');
    }

    static hideElement(element) {
        element.classList.add('hidden-screen');
        element.setAttribute('aria-hidden', 'true');
    }
}